var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.786,
    height: 25.786,
    viewBox: "883.531 2740.124 25.786 25.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-percent"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 78000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m907.705 2741.736-22.563 22.563",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m907.705 2741.736-22.563 22.563",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#9997df",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 78001"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.589 2744.153a4.03 4.03 0 1 1-8.058 0 4.03 4.03 0 0 1 8.058 0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.589 2744.153a4.03 4.03 0 1 1-8.058 0 4.03 4.03 0 0 1 8.058 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#9997df",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 78002"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.317 2761.881a4.03 4.03 0 1 1-8.058 0 4.03 4.03 0 0 1 8.058 0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.317 2761.881a4.03 4.03 0 1 1-8.058 0 4.03 4.03 0 0 1 8.058 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#9997df",
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/Discount.ddb573aa0604dd91ea9d3e8b8d32f05b.svg";
export { ForwardRef as ReactComponent };